<template>
  <div
    v-if="user"
    data-e2e="sidebar-user-profile-link"
    class="flex items-center gap-2 px-4 py-2 transition-colors rounded cursor-pointer hover:bg-gray-725"
    @click="router.push(store.isOrganization ? '/company/profile' : '/account/' + user.profile.slug)"
  >
    <b-avatar
      :url="user.profile.signed_picture_url"
      alt="user profile avatar"
      :initials="initials"
      size="xs"
    />
    <span class="text-base font-normal text-gray-300 leading-relaxed">
      {{ user.first_name }} {{ user.last_name }}
    </span>
  </div>
</template>

<script setup lang="ts">
import BAvatar from "~/components/avatar/BAvatar.vue";
import { authStore } from "~/stores/auth";
import { computed } from "vue";

const { t } = useI18n();
const store = authStore();

const { user } = storeToRefs(store);

const initials = computed(() => {
  const defaultValue = t('common.not_specified');
  return (user.value?.first_name || defaultValue)[0] + (user.value?.last_name || defaultValue)[0];
});

const router = useRouter();
</script>
